import { Container, Button } from './styles';
import { SuccessContainer, SuccessIcon, SuccessTitle, SuccessMessage } from './SuccessStyles';

export default function SuccessScreen({ onGoToLogin }) {
    return (
        <Container>
            <SuccessContainer>
                <SuccessIcon>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                </SuccessIcon>
                <SuccessTitle>Cadastro realizado!</SuccessTitle>
                <SuccessMessage>
                    Quase lá! Confirme seu cadastro. Um e-mail de confirmação foi enviado para você.
                </SuccessMessage>
                <Button onClick={onGoToLogin}>
                    Voltar
                </Button>
            </SuccessContainer>
        </Container>
    );
}
